/**
 * Freebet utility functions for dynamic welcome bonus display
 * Returns freebet values based on country code
 */

export interface FreebetValue {
  amount: number;
  currency: string;
  display: string;
}

/**
 * Get freebet value based on country code
 * @param countryCode - 2-letter country code (GT, DO, HN, etc.) or 'GLOBAL'
 * @returns FreebetValue with amount, currency, and display string
 */
export function getFreebetByCountry(countryCode: string): FreebetValue {
  const freebetMap: Record<string, FreebetValue> = {
    GT: {
      amount: 50,
      currency: 'GTQ',
      display: '50Q',
    },
    DO: {
      amount: 350,
      currency: 'DOP',
      display: '350 DOP',
    },
  };

  // Return country-specific freebet or default to USD
  if (freebetMap[countryCode]) {
    return freebetMap[countryCode];
  }

  // Default for all other countries
  return {
    amount: 5,
    currency: 'USD',
    display: '$5 USD',
  };
}

/**
 * Format freebet display text for sports bonus
 * @param countryCode - 2-letter country code or 'GLOBAL'
 * @returns Formatted string like "Pronostico Gratis de 50Q"
 */
export function formatFreebetDisplay(countryCode: string): string {
  const freebet = getFreebetByCountry(countryCode);
  return `Gratis de ${freebet.display}`;
}
